import { Window } from "@progress/kendo-react-dialogs";
import {
  columnsConstructorSessionData,
  editedPropertyValues as editedColumnPropertyValues,
  selectedColumnId,
} from "../../Fields/ColumnsConstructor/ColumnsConstructorSignals";
import {
  fieldFocusIndex,
  isGalleryEditor,
  selectedSectionName,
  selectedFieldName as selectedTemplateFieldName,
  selectedFieldType as selectedTemplateFieldType,
  templateData,
} from "../../Template/NewTemplateSignals";
import {
  editedPropertyValues,
  selectedFieldName,
  selectedFieldType,
} from "../GalleryConstructor/GalleryConstructorSignals";
import { conditionalFormattingVisibility } from "../Store/CommonSignals";
import ConditionRuleBuilder from "./ConditionRuleBuilder";

export const ConditionBuilderWindow = () => {
  const getFieldType = () => {
    if (isGalleryEditor.value) {
      return selectedFieldType.value;
    } else if (columnsConstructorSessionData.value.length > 0) {
      return columnsConstructorSessionData.value[selectedColumnId.value]?.columnType;
    } else {
      return selectedTemplateFieldType.value;
    }
  };
  const fieldType = getFieldType();
  const handlePropertyChange = ({ propName, propValue }) => {
    if (isGalleryEditor.value) {
      editedPropertyValues.value = {
        ...editedPropertyValues.value,
        [selectedFieldName.value]: {
          ...editedPropertyValues.value[selectedFieldName.value],
          [propName]: propValue,
        },
      };
    } else if (columnsConstructorSessionData.value.length > 0) {
      editedColumnPropertyValues.value = {
        ...editedColumnPropertyValues.value,
        [selectedColumnId.value]: {
          ...editedColumnPropertyValues.value[selectedColumnId.value],
          [propName]: propValue,
        },
      };
    } else if (fieldFocusIndex.value === null) {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              properties: {
                ...section.properties,
                [propName]: propValue,
              },
            };
          }
          return section;
        }),
      };
    } else {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              fields: section.fields.map((field) => {
                if (field.fieldName === selectedTemplateFieldName.value) {
                  return {
                    ...field,
                    properties: {
                      ...field.properties,
                      [propName]: propValue,
                    },
                  };
                }
                return field;
              }),
            };
          }
          return section;
        }),
      };
    }
  };

  return (
    <>
      {conditionalFormattingVisibility.value && (
        <Window
          onClose={() => (conditionalFormattingVisibility.value = false)}
          initialHeight={500}
          initialWidth={800}
          title={"Conditional Formatting Rules Manager"}
        >
          <ConditionRuleBuilder
            handlePropertyChange={handlePropertyChange}
            fieldType={fieldType}
            onClose={() => (conditionalFormattingVisibility.value = false)}
          />
        </Window>
      )}
    </>
  );
};
